/* Copyright (c) 2026 Dobler Data Solutions, LLC. All rights reserved. */

export function Footer() {
  const version = import.meta.env.VITE_APP_VERSION || 'dev';

  return (
    <footer className="bg-gray-50 border-t border-gray-200 text-xs text-gray-400 py-2 px-4 shrink-0 flex justify-between items-center">
      <span>© 2026 Dobler Data Solutions, LLC</span>
      <span>v{version}</span>
    </footer>
  );
}
